<script>
    import FriendRow from './FriendRow.svelte';

    export let requests;

    // TODO: make incoming and outgoing just one.

    $: console.log('requests in OutgoingFriendRequests:', requests);
</script>

<h4>Friend requests sent</h4>
{#each requests as request, i}
	<FriendRow
		friend={request}
		type="outgoing"
        onCancel={(event) => {
            console.log(event);
        }}
	/>
{:else}
    <p>No friend requests sent!</p>
{/each}
